// entries/admin_extension_tokens/components/StatusBadge.jsx
import React from "react"
import { useTranslation } from "react-i18next"

const StatusBadge = ({ token }) => {
  const { t } = useTranslation()

  if (!token || !token.active) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#F4F6F9] text-[#9AA5B4] text-xs font-medium">
        <span className="w-1.5 h-1.5 rounded-full bg-[#C7CDD6]" />
        {t("admin_extension_tokens.badge.no_token")}
      </span>
    )
  }

  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#E9F9EF] text-[#16A34A] text-xs font-medium">
      <span className="w-1.5 h-1.5 rounded-full bg-[#16A34A]" />
      {token.token_prefix}…
    </span>
  )
}

export default StatusBadge
